import React from 'react';

const IncreaseFreeTrial = ({ numberOfDays, setNumberOfDays }) => {
  return (
    <div>
      <div className='input-group mb-3 '>
        <p className='input-group-text w-1/2'>Free trial days: </p>
        <input
          type='number'
          value={numberOfDays}
          onChange={e => setNumberOfDays(e.target.value)}
          className='form-control '
          placeholder=''
          min={1}
          max={42}
          required
        />
      </div>
    </div>
  );
};

export default IncreaseFreeTrial;
